/** PURE_IMPORTS_START ._ForkJoinObservable PURE_IMPORTS_END */
import { ForkJoinObservable } from './ForkJoinObservable';
export var forkJoin = ForkJoinObservable.create;
//# sourceMappingURL=forkJoin.js.map 



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/rxjs/_esm5/observable/forkJoin.js
// module id = ../../../../rxjs/_esm5/observable/forkJoin.js
// module chunks = vendor